import Vue from 'vue'
import VueRouter from 'vue-router'
import {Role} from '@/_helpers/role'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('@/views/Home.vue'),
  },
  {
    path: '/divulgacao',
    component: () => import('@/views/DivulgacaoPublica.vue'),
    meta: {
      layout: "simple-layout",
      meta: {
        titulo: 'Login'
      }
    }    
  },
  { 
    path: '/administrador', 
    component: {
      render(c) {
        return c('router-view');
      }
    },
    children: [
      {
        path: '', 
        name: 'admin', 
        component: () => import('@/views/admin/Admin.vue'),
        meta: {
          titulo: 'Administração',
          authorize: [Role.admin, Role.documentacao, Role.pcd, Role.raca, Role.renda]
        },
      },
    ]
  },
  { 
    path: '/candidato', 
    component: {
      render(c) {
        return c('router-view');
      }
    },
    children: [
      {
        path: '', 
        name: 'candidatoHome', 
        component: () => import('@/views/candidato/Home.vue'),
        meta: {
          titulo: 'Home',
          authorize: [Role.candidato]
        },
      },
      {
        path: '/inscricao', 
        name: 'inscricao', 
        component: () => import('@/views/candidato/Inscricao.vue'),
        meta: {
          titulo: 'Home',
          authorize: [Role.candidato]
        },
      },
      {
        path: '/acompanhamento',
        name: 'acompanhamento',
        component: () => import('@/views/candidato/Acompanhamento.vue'),
        meta: {
          titulo: 'Acompanhamento',
          authorize: [Role.candidato]
        },
      },
    ]
  },
  { 
    path: '/403', 
    name: 'forbidden',
    component: () => import('@/views/403.vue'),
    meta: {
      titulo: 'ERRO'
    }
  },
  { 
    path: '/login', 
    name: 'login', 
    component: () => import('@/views/Login.vue'),
    meta: {
      layout: "simple-layout",
      meta: {
        titulo: 'Login'
      }
    }
  },
  { 
    path: '*', 
    name: 'notFound',
    component: () => import('@/views/404.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const publicPages = ['/login','/divulgacao'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');

  // trying to access a restricted page + not logged in
  // redirect to login page
  if (authRequired) {
    if (!loggedIn) {
      return next('/login');
    }
  }


  // redirect to login page if not logged in and trying to access a restricted page
  const { authorize } = to.meta;
  const currentUser = store.getters.loggedUser;

  if (authorize) {
      if (!currentUser) {
          // not logged in so redirect to login page with the return url
          return next({ path: '/login' });
      }

      // check if route is restricted by role
      if (authorize.length && !authorize.includes(currentUser.role)) {
          // role not authorised so redirect to home page
          return next({ path: '/login' });
      }
  }
  next();
});

export default router;
